<template>
  <div class="home relative z-10">
    <header class="container-header">
      <h1 class="title">
        Select the animal type
      </h1>
    </header>

    <div class="bg-grey-lightest rounded-medium px-5 py-5 md:px-10 2xl:px-40 md:py-10 2xl:py-20">
      <AnimalType/>

      <Navigation
        v-bind="{
          prev: {disabled: true},
          next: {disabled: isNextDisabled, isHidden: false},
        }"
        @click="onNavigationClick($event, '', nextRoute)"
      />
    </div>
  </div>
</template>

<script>
import Navigation from '@/components/Navigation';
import NavigationMixin from '@/mixins/NavigationMixin';
import AnimalType from '@/components/AnimalType';
import { mapActions, mapGetters, mapState } from 'vuex'

export default {
  name: 'Home',

  mixins: [NavigationMixin],

  components: {
    AnimalType,
    Navigation
  },

  created() {
    this.fetchSelectedProduct()
  },

  methods: {
    ...mapActions({
      fetchSelectedProduct: 'productSelect/fetchSelectedProduct'
    })
  },

  computed: {
    ...mapGetters({
      getActiveAnimalType: 'animalType/getActiveAnimalType',
      getSelectedProduct: 'productSelect/getSelectedProduct'
    }),

    ...mapState('animalType', {
      animalTypes: state => state.animalTypes,
    }),

    isNextDisabled() {
      // If actino active animal is selected, disable the button
      if (!this.getActiveAnimalType) {
        return true;
      }

      // If the active animal type has items property, ensure a child is selected by checking the isActive property
      if (this.getActiveAnimalType.items && this.getActiveAnimalType.items.length > 0) {
        return !this.getActiveAnimalType.items.some(item => item.isActive);
      }

      // If no children, the parent selection is sufficient
      return false;
    },

    nextRoute() {
      // If selected animalType is aqua then skip the feed step
      if (this.getActiveAnimalType?.type === 'aqua') {
        return 'phases'
      }
      return 'feed-view'
    }
  },
}
</script>
